import React from "react";
import "./CartSheet.css";
import { useCart } from "../context/CartContext";

export default function CartSheet({ onViewCart }) {
  const { itemCount, grandTotal } = useCart();

  // The floating cart bar (always visible when there are items).
  if (itemCount === 0) return null;

  return (
    <button
      className="cart-bar"
      onClick={onViewCart}
      aria-label="View cart"
    >
      <span className="cart-bar-badge">{itemCount}</span>
      <span className="cart-bar-info">
        <span className="cart-bar-label">{itemCount} item{itemCount === 1 ? "" : "s"}</span>
        <strong className="cart-bar-total">₹{Math.round(grandTotal)}</strong>
      </span>
      <span className="cart-bar-cta">View Cart →</span>
    </button>
  );
}